/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Stop_Call_DelayInputs */

const fr_stop_call_delay = /** @type {(inputs: Stop_Call_DelayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retard de ${i?.count} minute${i?.plural}`)
};

const en_stop_call_delay = /** @type {(inputs: Stop_Call_DelayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minute${i?.plural} late`)
};

/**
* | output |
* | --- |
* | "{count} minute{plural} late" |
*
* @param {Stop_Call_DelayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const stop_call_delay = /** @type {((inputs: Stop_Call_DelayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stop_Call_DelayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_stop_call_delay(inputs)
	return en_stop_call_delay(inputs)
});